/**
 * F2-d cluster login multi-hotel: Step 0 della LoginPage — scelta dell'hotel.
 *
 * Il gestionale online (api-edge) serve i 3 hotel reali con un solo backend
 * multi-tenant; l'operatore sceglie qui l'hotel, poi il suo tenant_id (hotelId)
 * viene passato a `/auth/operators` (griglia operatori scopata per tenant) e a
 * `/auth/login-pin` (validazione PIN nel tenant corretto).
 *
 * Riusa lo stile `.operators-grid`/`.operator-card` per coerenza visiva.
 */
import { HOTELS, type HotelOption } from '../../config/hotels.js';

export function HotelSelectStep({ onSelect }: { onSelect: (hotel: HotelOption) => void }) {
  return (
    <div data-testid="hotel-select-step">
      <div className="section-title">Seleziona hotel</div>
      <div className="operators-grid">
        {HOTELS.map((hotel) => (
          <button
            key={hotel.id}
            type="button"
            className="operator-card"
            onClick={() => onSelect(hotel)}
            aria-label={`Seleziona hotel ${hotel.name}`}
            data-testid={`hotel-card-${hotel.id}`}
          >
            <div className="operator-avatar reception">
              {hotel.name
                .split(' ')
                .map((w) => w[0])
                .join('')
                .slice(0, 2)
                .toUpperCase()}
            </div>
            <div>
              <div className="operator-name">{hotel.name}</div>
              <div className="operator-role reception">{hotel.subtitle}</div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
